export default "__VITE_ASSET__IP5olzn1__"